import React, { useState, useEffect } from 'react';
import InformationForm from './InformationForm';
import GuestManager from './GuestManager';
import DesignEditor from './DesignEditor';
import BlogManager from '../blog/BlogManager';

const SeminarEditor = ({ user, seminar, onSave, onPublish, onUnpublish, onBackToDashboard, onSignOut }) => {
    const [activeTab, setActiveTab] = useState('informations');
    const [internalSeminar, setInternalSeminar] = useState(seminar);
    
    useEffect(() => {
        setInternalSeminar(seminar);
    }, [seminar]);

    const handleInternalSave = (updatedData) => {
        const updatedSeminar = { ...internalSeminar, ...updatedData };
        setInternalSeminar(updatedSeminar);
        onSave(updatedSeminar);
    };

    const handlePublishClick = () => {
        if (seminar.isPublished) {
            if (window.confirm("Êtes-vous sûr de vouloir mettre ce séminaire hors ligne ? Le lien public ne sera plus accessible.")) {
                onUnpublish(seminar.id);
            }
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir publier ce séminaire ? Il sera visible par les invités.")) {
                onPublish(seminar.id);
            }
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'informations': return <InformationForm seminar={internalSeminar} onSave={handleInternalSave} />;
            case 'invites': return <GuestManager seminar={internalSeminar} onSave={handleInternalSave} />;
            case 'design': return <DesignEditor seminar={internalSeminar} onSave={handleInternalSave} />;
            case 'photos': return <BlogManager seminar={internalSeminar} onSave={handleInternalSave} />;
            default: return <InformationForm seminar={internalSeminar} onSave={handleInternalSave} />;
        }
    };

    return (
        <div className="flex h-screen bg-white">
            <aside className="w-1/5 bg-black text-white flex-col p-6 hidden md:flex">
                <div className="mb-10"><h1 className="text-2xl font-bold italic tracking-widest text-white">MY SEMINAR.</h1></div>
                <div className="flex-1">
                    <nav className="space-y-2">
                        <button onClick={onBackToDashboard} className="w-full text-left nav-link block text-lg p-3 hover:bg-gray-800 rounded-md">&larr; Tableau de bord</button>
                        <hr className="border-gray-700 my-4" />
                        <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab('informations'); }} className={`nav-link block text-lg p-3 hover:bg-gray-800 rounded-md ${activeTab === 'informations' ? 'active' : ''}`}>Mon séminaire</a>
                        
                        <a href="#" onClick={(e) => { e.preventDefault(); if (internalSeminar.isLocked) setActiveTab('invites'); }} className={`nav-link block text-lg p-3 rounded-md transition-colors ${activeTab === 'invites' ? 'active' : ''} ${internalSeminar.isLocked ? 'hover:bg-gray-800' : 'opacity-50 cursor-not-allowed'}`} title={!internalSeminar.isLocked ? "Veuillez d'abord valider les informations du séminaire" : "Gérer les invités"}>Invités</a>
                        
                        <a href="#" onClick={(e) => { e.preventDefault(); if (internalSeminar.isLocked) setActiveTab('design'); }} className={`nav-link block text-lg p-3 rounded-md transition-colors ${activeTab === 'design' ? 'active' : ''} ${internalSeminar.isLocked ? 'hover:bg-gray-800' : 'opacity-50 cursor-not-allowed'}`} title={!internalSeminar.isLocked ? "Veuillez d'abord valider les informations du séminaire" : "Modifier le design"}>Design</a>
                        
                        <a href="#" onClick={(e) => { e.preventDefault(); if (internalSeminar.isLocked && internalSeminar.hasBlog) setActiveTab('photos'); }} className={`nav-link block text-lg p-3 rounded-md transition-colors ${activeTab === 'photos' ? 'active' : ''} ${internalSeminar.isLocked && internalSeminar.hasBlog ? 'hover:bg-gray-800' : 'opacity-50 cursor-not-allowed'}`} title={!internalSeminar.isLocked || !internalSeminar.hasBlog ? "Validez les informations et activez le blog d'abord" : "Gérer les photos"}>Photos Blog</a>
                    </nav>
                </div>
                <div className="mb-6">
                    <button onClick={handlePublishClick} className={`w-full text-white font-bold py-3 px-4 rounded-lg transition-colors text-lg ${seminar.isPublished ? 'bg-red-500 hover:bg-red-600' : 'bg-[#22D6B5] hover:bg-opacity-90'}`}>
                        {seminar.isPublished ? 'Mettre hors ligne' : 'Publier'}
                    </button>
                </div>
            </aside>
            <div className="w-full md:w-4/5 flex flex-col">
                <header className="flex justify-end items-center px-10 py-4 border-b h-[88px]">
                    <div className="flex items-center gap-4">
                        <span className="font-semibold">{user.email}</span>
                        <button onClick={onSignOut} className="text-red-500 hover:text-red-700 font-semibold">Déconnexion</button>
                    </div>
                </header>
                <main className="flex-1 bg-white overflow-y-auto">{renderContent()}</main>
            </div>
        </div>
    );
};

export default SeminarEditor;